const nanoid = require("nanoid")
const { parseNumber } = require("libphonenumber-js")
var addressParser = require("parse-address")

export function uuid() {
  return nanoid()
}

export function isValidEmail(email: string | null | undefined) {
  if (!email) return false
  var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
  return re.test(String(email).toLowerCase())
}

export function isValidPhone(phone: string | null | undefined) {
  if (!phone) return false
  const parsedNumber = parseNumber(String(phone), "US")
  return parsedNumber != undefined && parsedNumber.phone != undefined
}

export const hasKeySpaceDelims = (value: string, num = 3) => {
  return (value.match(/:/g) || []).length === num
}

export function debounce<T>(
  func: () => void,
  wait: number,
  immediate?: boolean
) {
  let timeout: any | undefined

  return function executedFunction(this: T) {
    var context: any = this
    var args = arguments

    var later = function() {
      timeout = undefined
      if (!immediate) func.apply(context, args)
    }

    var callNow = immediate && !timeout

    clearTimeout(timeout)

    timeout = setTimeout(later, wait)

    if (callNow) func.apply(context, args)
  }
}

export function hasMinChars(str?: string, minLength: number = 1): boolean {
  if (minLength === void 0) {
    minLength = 1
  }
  return str ? str.length >= minLength : false
}

export function requiredText(obj: any, propName: string): boolean {
  if (!obj[propName] || typeof obj[propName] !== "string") return false
  return true
}

export function requiredTextOrNum(obj: any, propName: string) {
  if (
    !obj[propName] ||
    (typeof obj[propName] !== "string" && typeof obj[propName] !== "number")
  )
    return false
  return true
}

export function isValidAddress(address: {
  [name: string]: any
  street?: string
  city?: string
  state?: string
  zip?: string
}) {
  const longAddress = `${address.street} ${address.city} ${address.state} ${
    address.zip
  } `

  const parsed = addressParser.parseLocation(longAddress)
  if (parsed && parsed.street && parsed.city && parsed.state && parsed.zip) {
    return true
  }
  return false
}

export function lightDBHost() {
  if (window && window.location.href.indexOf("localhost") != -1)
    return "http://localhost:3331"
  if (window && window.location.href.indexOf("stage") != -1)
    return "https://dotcomlight.cf/stage"

  return "https://dotcomlight.cf"
}

export function cleanAddress(address: {
  [name: string]: any
  street?: string
  city?: string
  state?: string
  zip?: string
}) {
  const longAddress = `${address.street} ${address.city} ${address.state} ${
    address.zip
  } `

  const parsed = addressParser.parseLocation(longAddress)
  if (parsed) {
    if (parsed.street) address.street = parsed.street.trim()
    if (parsed.prefix) address.street = `${parsed.prefix} ${address.street}`
    if (parsed.number) address.street = `${parsed.number} ${address.street}`

    address.city = parsed.city
    address.state = parsed.state
    address.zip = parsed.zip
  }
  return parsed
}

export function checkForLastNameInFirstName(object: any) {
  if (
    !object.lastName &&
    object.firstName &&
    object.firstName.trim().indexOf(" ") != -1
  ) {
    const names = object.firstName.split(" ")
    if (names.length > 1) {
      object.firstName = names[0]
      object.lastName = names[1]
    }
  }
}
